import { format } from "date-fns";
import { WeeklySummaryRecipient } from "./weekly_summary_recipient";

export class WeeklySummaryRecipients extends Array<WeeklySummaryRecipient> {
  constructor(weeklySummaryRecipients?: WeeklySummaryRecipient[]) {
    super();
    if (weeklySummaryRecipients instanceof Array) {
      weeklySummaryRecipients.forEach((weeklySummaryRecipient) =>
        this.push(weeklySummaryRecipient),
      );
    }
  }

  get local_last_updated_at(): Date | undefined {
    return this.length === 0
      ? undefined
      : this.map((weeklySummaryRecipient) =>
          weeklySummaryRecipient.created_at
            ? new Date(weeklySummaryRecipient.created_at)
            : undefined,
        ).sort((a, b) => (b?.getTime() ?? 0) - (a?.getTime() ?? 0))[0];
  }

  get local_last_updated_at_datetime_string(): string | undefined {
    if (!this.local_last_updated_at) return undefined;
    return format(this.local_last_updated_at, "MMM d, hh:mm aaa");
  }
}
